import React, { useState } from 'react';
import { IconButton, ListItem, ListItemText, ListItemSecondaryAction } from '@mui/material';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import { useDeleteTaskMutation, useUpdateTaskMutation } from './redux/fullApi';
import TaskModal from './TaskModal';

const TaskItem = ({ task }) => {


  const [updateTask] = useUpdateTaskMutation()
  const [deleteTask] = useDeleteTaskMutation()

  const handleEditClick = () => {
    // Handle edit click logic here
    handleOpenModal()
  };

  const handleDeleteClick = () => {
    // Handle delete click logic here
    deleteTask({id: task.id})
  };

  const handleUpdate = () => {
    // handle update the status to completed
    updateTask({id: task.id, name: task.name, completed: 'true'}, {id: task.id}).then(res => {
      console.log("Res is", res)
    }).catch((e) => {
      console.log("E IS", e)
    })
  }

  const [isModalOpen, setIsModalOpen] = useState(false);

  const handleOpenModal = () => {
    setIsModalOpen(true);
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
  };


  return (
    <>
    <ListItem
      sx={{
        width: '750px',
        listStyle: 'none', // Remove list bullet points
        '&::marker': {
          display: 'none', // Hide the marker/bullet point
        },
        color:'#fff',
        backgroundColor: task.completed==='true' && '#8BC34A !important',
        borderRadius:'10px',
        mb:2
      }}
    >
      <ListItemText primary={task.name} />
      <ListItemSecondaryAction>
      <IconButton edge="end" aria-label="edit" onClick={handleUpdate} color="secondary">
          <CheckCircleIcon />
        </IconButton>
        <IconButton edge="end" aria-label="edit" onClick={handleEditClick} color="secondary">
          <EditIcon />
        </IconButton>
        <IconButton edge="end" aria-label="delete" onClick={handleDeleteClick} color="secondary">
          <DeleteIcon />
        </IconButton>
      </ListItemSecondaryAction>
    </ListItem>
    <TaskModal operation="update" task={task} isOpen={isModalOpen} handleClose={handleCloseModal} />
    </>

  );
};

export default TaskItem;
